// React import
import { useState, useRef } from 'react';

// Generic imports
import _ from 'lodash';

// MUI import
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';

// Local import
import AccountAutoSuggest from '../accounts/AccountAutoSuggest.js';

function OpportunityAccountPane(props) {
    const { account, setAccount, errors = [], accounts, setErrors = () => {}, width = 'calc(33% + 3px)' } = props;
    const [ accountWarning, setAccountWarning ] = useState(false);
    const isSelectingRef = useRef(false);

    return (
        <>
            <Box sx={{ width }}>
                <AccountAutoSuggest
                    account={account}
                    setAccount={(v) => {
                        // Mark that we're selecting a suggestion to prevent onBlur from interfering
                        isSelectingRef.current = true;
                        setErrors(_.without(errors, 'name'));
                        setAccount({ ...v });
                        // Reset the flag after a short delay
                        setTimeout(() => {
                            isSelectingRef.current = false;
                        }, 300);
                    }}
                    suggestions={accounts.filter(a => !a.inactive)}
                    error={errors.includes('name')}
                    onBlur={(e) => {
                        // Don't process blur if we just selected a suggestion
                        if (isSelectingRef.current) {
                            return;
                        }

                        const targetValue = e.target.value;
                        if (!targetValue) {
                            if (!account.id) setErrors(['name']);
                            return;
                        }

                        // Use a timeout to allow suggestion click to complete first
                        setTimeout(() => {
                            // Double-check we're not in the middle of selecting
                            if (isSelectingRef.current) {
                                return;
                            }

                            // Check if account was already set (from suggestion selection)
                            if (account.id && account.name === targetValue) {
                                setErrors(_.without(errors, 'name'));
                                setAccountWarning(false);
                                return;
                            }

                            setErrors(_.without(errors, 'name'));
                            const a = accounts.find(ac => _.trim(ac.name.toUpperCase()) === _.trim(targetValue.toUpperCase()));
                            if (a) {
                                setAccount({ ...a });
                                setAccountWarning(false);
                            } else {
                                // Only update if the value is different from current account name
                                // Don't update if the value matches what's already in the input
                                if (account.name !== targetValue) {
                                    setAccount({ name: targetValue });
                                }
                                setAccountWarning(true);
                            }
                        }, 200);
                    }}
                />
            </Box>

            {errors.includes('name') && (
                <Alert severity='error'>
                    Please select an account.
                </Alert>
            )}

            {accountWarning && !account.id && (
                <Alert severity='warning' sx={{ flex: 1, marginTop: '16px', marginBottom: '6px' }}>
                    You don't have this account in your system. We will add it for you.
                </Alert>
            )}
        </>
    );
}

export default OpportunityAccountPane;
